import { motion, AnimatePresence } from "framer-motion";
import DocsSidebarNav from "./DocsSidebarNav";
import mobileStyles from "../../styles/docs/docsMobile.module.scss";

const DocsMobileDrawer = ({ open, onClose, docNav, activeId, onNavigate }) => (
  <AnimatePresence>
    {open && (
      <>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className={mobileStyles.overlay}
          onClick={onClose}
          aria-hidden="true"
        />
        <motion.aside
          initial={{ x: -320 }}
          animate={{ x: 0 }}
          exit={{ x: -320 }}
          transition={{ type: "spring", damping: 28, stiffness: 280 }}
          className={mobileStyles.drawer}
        >
          <DocsSidebarNav
            docNav={docNav}
            activeId={activeId}
            onNavigate={onNavigate}
            variant="drawer"
          />
        </motion.aside>
      </>
    )}
  </AnimatePresence>
);

export default DocsMobileDrawer;
